import React, { useCallback, useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { useLocation, Navigate } from "react-router-dom";
import Return from "./ReturnPage";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const Checkout = () => {
  const location = useLocation();
  const [error, setError] = useState(null);
  const [isComplete, setIsComplete] = useState(false);

  const rentalDetails = location.state;

  const fetchClientSecret = useCallback(() => {
    return fetch(`${backendUrl}/api/create-checkout-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        price: rentalDetails.price,
        rental_date: rentalDetails.rental_date,
        return_date: rentalDetails.return_date,
        car_id: rentalDetails.car_id,
        driver: rentalDetails.include_driver,
        car_name: rentalDetails.car_name,
        car_photo: rentalDetails.photo,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((err) => {
            throw new Error(err.error || "Failed to fetch client secret");
          });
        }
        return res.json();
      })
      .then((data) => {
        if (!data.clientSecret) {
          throw new Error("Client secret not provided");
        }
        return data.clientSecret;
      })
      .catch((err) => {
        setError(err.message);
        throw err;
      });
  }, [rentalDetails]);

  const options = { fetchClientSecret };

  return isComplete ? (
    <Return />
  ) : (
    <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
};

export default Checkout;
